export function isInViewPort(el: HTMLElement, viewPercent: number): boolean {
  const rect = el.getBoundingClientRect();

  const windowHeight = window.innerHeight || document.documentElement.clientHeight;
  const windowWidth = window.innerWidth || document.documentElement.clientWidth;

  const vertBottomInView = rect.top - rect.height * viewPercent + rect.height >= 0;
  const vertTopInView = rect.top + rect.height * viewPercent <= windowHeight;
  const horLeftInView = rect.left + rect.width * viewPercent <= windowWidth;
  const horRightInView = rect.left - rect.width * viewPercent + rect.width >= 0;

  return vertBottomInView && horRightInView && vertTopInView && horLeftInView;
}
